// extracted by mini-css-extract-plugin
export default {"becomeDealerPage":"style_becomeDealerPage__9K2dL","becomeDealerInner":"style_becomeDealerInner__hQ4lz","loaderBox":"style_loaderBox__INYhX","successBox":"style_successBox__rxeQe"};